import type { WProductLookView, WProductView } from '@zola/svc-web-api-ts-client';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';

import { BreadCrumbs } from './BreadCrumb';
import ImageCarousel from './ImageCarousel';

type CarouselBreadCrumbProps = {
  productData: WProductView | null;
  activeProductLook: WProductLookView | undefined;
  personalizedImageUrl: any;
  fromChecklistQueryParam?: string;
};
export const CarouselBreadCrumb = (props: CarouselBreadCrumbProps) => {
  const { productData, activeProductLook, personalizedImageUrl, fromChecklistQueryParam } = props;
  if (!productData || !activeProductLook) return null;
  const brandName = productData.brand?.name;
  const brandKey = productData.brand?.key;
  const productName = productData.display_name;
  return (
    <div className="carousel-breadcrumb_container">
      <BreadCrumbs
        crumbKey={activeProductLook.key}
        productData={productData}
        className="show-screen-lg"
        fromChecklistQueryParam={fromChecklistQueryParam}
      />
      <div className="brand-product-names-mobile">
        <LinkV2
          variant="primary"
          noUnderline
          href={`/shop/brand/${brandKey}`}
          className="brand-name"
        >
          {brandName}
        </LinkV2>
        <h3 className="product-name">{productName}</h3>
        <div
          data-bv-seo="false"
          className="product-rating"
          data-bv-product-id={productData.id}
          data-bv-show="rating_summary"
        />
      </div>
      {activeProductLook && (
        <ImageCarousel
          personalizedImageUrl={personalizedImageUrl}
          productData={productData}
          activeProductLook={activeProductLook}
        />
      )}
    </div>
  );
};
